import { Injectable, InjectionToken, Inject } from '@angular/core';
import { catchError, map, tap, last, switchMap } from 'rxjs/operators';
// tslint:disable-next-line:import-blacklist
import { Observable ,  of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpEventType, HttpEvent, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { ApiResponse } from '../shared/classes/api';
import { WINDOW } from '../shared/providers/window';
import { ApiConfig } from '../shared/classes/api-config';
import { StorageService } from '../../shared/services/storage.service';
import {Router, UrlSerializer} from '@angular/router';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
export type PaginationQuery = {
    page?: number;
    perPage?: number;
    logiciel?: string;
    batimentId?: string;
    lotId?: string;
    etat?: string;
};
@Injectable()
export class ApiService {

    subdomain: string;
    config: ApiConfig;

    constructor(
        @Inject(WINDOW) private window: Window,
        private http: HttpClient,
        private storageService: StorageService,
        private router: Router,
        private serializer: UrlSerializer
    ) {
        // Récupération du sous domaine et chargement du fichier de config
        const hostname = this.window.location.hostname;
        this.subdomain = hostname.split('.')[0];
        this.storageService.setSubdomain(this.subdomain);

    }

    getInstanceConfig(): Observable<any> {
        return this.http.get('assets/config/' + this.subdomain + '.json')
        .pipe(
            tap((retour: ApiConfig) => {
                this.config = retour;
                this.storageService.setApiUrl(retour.url);
            })
        );
    }

    getConfig(): ApiConfig {
        return this.config;
    }

    request (methode: string, uri: string, data?: any, options?: {}): Observable<ApiResponse> {
        return this.http[methode](this.config.url + uri, data, options ? options : httpOptions)
        .pipe(
            tap(retour => {}),
            catchError(this.handleError('request', []))
        );
    }

    creatUrlQuery(query: {}) {
        let queryString  = '?';

        Object.keys(query).forEach(item => {
            if (query[item] !== undefined && query[item] !== null) {
                queryString += queryString !== '?' ? '&' : '';
                queryString += `${item}=${query[item]}`;
            }
        });

        return queryString;
    }

    get (uri: string, options?: {}, query?: {}, cached?: string): Observable<any> {
        if (cached) {
            return this.getCached(uri, cached, options, query)
        }
        if (query)
            uri += this.creatUrlQuery(query);
        return this.http.get(this.config.url + uri, options ? options : httpOptions)
        .pipe(
            tap(retour => {}),
            catchError(this.handleError('post', []))
        );
    }


    getCached (uri: string, key: string, options?: {}, query?: {}): Observable<any> {
        const httpOptionsCached = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "store-cache" : key })
        };

        if (query)
            uri += this.creatUrlQuery(query);
        return this.http.get(this.config.url + uri, httpOptionsCached)
        .pipe(
            tap(retour => {
                if (!this.isHttpError(retour)) {
                    return retour;
                } else {
                    this.handleError('post', []);
                }
            }),
            catchError(this.handleError('post', []))
        );
    }


    post (uri: string, data?: any, options?: {}, query?: {}): Observable<any> {
        if (query)
            uri += this.creatUrlQuery(query);
        return this.http.post(this.config.url + uri, data, options ? options : httpOptions)
        .pipe(
            tap(retour => {}),
            catchError(this.handleError('post', []))
        );
    }

    put (uri: string, data?: any, query?: {}): Observable<any> {
        if (query)
            uri += this.creatUrlQuery(query);
        return this.http.put(this.config.url + uri, data, httpOptions)
        .pipe(
            tap(retour => {}),
            catchError(this.handleError('put', []))
        );
    }

    patch (uri: string, data?: any): Observable<any> {
        return this.http.patch(this.config.url + uri, data, httpOptions)
            .pipe(
                tap(retour => {}),
                catchError(this.handleError('patch', []))
            );
    }

    patchList (uri: string, data?: any): Observable<any> {
        const req = new HttpRequest('PATCH', this.config.url + uri, data, {});

        return this.http.request(req)
            .pipe(
                tap(retour => {}),
                last(),
                catchError(this.handleError('patch', [])));
    }

    deleteList(uri: string, data: any): Observable<any> {
        const req = new HttpRequest('DELETE', this.config.url + uri, data, {});

        return this.http.request(req)
            .pipe(
                tap(retour => {}),
                last(),
                catchError(this.handleError('delete', [])));
    }

    delete (uri: string, query?: {}): Observable<any> {
        if (query)
            uri += this.creatUrlQuery(query);
        return this.http.delete(this.config.url + uri, httpOptions)
        .pipe(
            tap(retour => {}),
            catchError(this.handleError('delete', []))
        );
    }


    upload(uri: string, data?: any, getEvent?: Function): Observable<any> {
        const req = new HttpRequest('POST', this.config.url + uri, data, {
            reportProgress: true
        });

        return this.http.request(req)
        .pipe(
            map(event => getEvent ? getEvent(event) : this.getEventMessage(event)),
            tap(retour => {}),
            last(),
            catchError(this.handleError('post', []))
        );
    }


    getEventMessage(event: HttpEvent<any>) {
        switch (event.type) {
            case HttpEventType.Sent:
                return `Uploading file  of size.`;

            case HttpEventType.UploadProgress:
                // Compute and show the % done:
                const percentDone = Math.round(100 * event.loaded / event.total);
                return `File is ${percentDone}% uploaded.`;

            case HttpEventType.Response:
                return `File was completely uploaded!`;

            default:
                return `File urprising upload event: ${event.type}.`;
        }
    }

    showProgress(message: string) {
    }

    isHttpError(retour): boolean {
        let result = false;

        if (retour === undefined || retour['status'] === undefined || (retour['status'] && this.isSuccessHTTPCode(retour['status']))) {
            result = false;
        } else {
            result = true;
        }

        // Gestion ArrayBuffer -> Get modèle de fiche bien
        /*if (retour instanceof ArrayBuffer) {
            const encodedString = String.fromCharCode.apply(null, new Uint8Array(retour));
            const safeHtml = this.sanitizer.bypassSecurityTrustHtml(encodedString);
            const jsonString = this.sanitizer.sanitize(SecurityContext.HTML, safeHtml);
            let json = null;
            try {
                json = JSON.parse(jsonString);
            } catch (err) {}

            if (json && json['status'] && json['status'] !== 200) {
                result = true;
            }
        }*/

        return result;
    }

    isSuccessHTTPCode(httpCode: number): boolean {
        const stringyfiedHTTPCode = httpCode.toString();
        const firstNumber = stringyfiedHTTPCode.substr(0, 1);

        return firstNumber === '2';
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T> (operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            if (error && error.error) {
                console.error(error.error); // log to console instead

                // TODO: better job of transforming error for user consumption
                this.log(`${operation} failed: ${error.message}`);
            }
            // Let the app keep running by returning an empty result.
            return of(error as T);
        };
    }

    /** Log a HeroService message with the MessageService */
    private log(message: string) {
        // this.messageService.add('HeroService: ' + message);
    }

    /*
    handleResponse(res: Response): ServerResponse {
        // My API sends a new jwt access token with each request,
        // so store it in the local storage, replacing the old one.
        this.refreshToken(res);
        const data = res.json();
        if (data.error) {
        const error: Error = { error: data.error, message: data.message };
        throw new Error(this.errorHandler.parseCustomServerErrorToString(error));
        } else {
        return data;
        }
    }


    refreshToken(res: Response) {
        const token = res.headers.get(appVariables.accessTokenServer);
        if (token) {
        localStorage.setItem(appVariables.accessTokenLocalStorage, `${token}`);
        }
    }
    */
}
